import styled from "styled-components";

export const TextViewWrap = styled.div`
  text-align: center;
  max-height: 100%;
  width: 100%;
  white-space: nowrap;
`;
